export default "__VITE_ASSET__4L1Xx2NF__"